<template>
  <div>
    <v-chip
      :color="bgColor"
      :text-color="textColor">{{ status }}</v-chip>
  </div>
</template>
<script>
export default {
  props: ['status'],
  computed: {
    bgColor () {
      switch (this.status) {
        case 'New':
          return '#ecf0f1'
        case 'Request Validation in Progress':
          return '#f1c40f'
        // case 'Completed':
        //   return '#e67e22'
        //   break;
        case 'Account Configuration in Progress':
          return '#95a5a6'
        case 'Account Creation Completed':
          return '#2ecc71'
        case 'Delivered to Requestor':
          return '#3498db'
        // case 'Delivery Onboarding In Progress':
        //   return '#f1c40f'
        //   break;
        case 'ORR In Progress':
          return '#a5b6b7'
        case 'Handover to CloudOps':
          return '#91babc'
        case  'Pending OppReg':
          return '#b7cdce'
        case  'Request Cancelled':
          return '#FF5733'
        default:
          return '#fff'
      }
    },
    textColor () {
      return this.status === 'New' || this.status === 'None' ? '#000' : '#fff'
    }
  }
}
</script>
